import { createModel } from '@rematch/core';
import { IRootModel } from 'app/store';
import { IPhysicianListState } from 'entities/Physician/Physician.models';
import { physicianListReducers } from 'entities/Physician/Physician.reducers';
import { physicianListEffects } from 'entities/Physician/Physician.effects';

export const physicianList = createModel<IRootModel>()({
  state: {
    data: null,
    loading: false,
  } as IPhysicianListState,
  reducers: physicianListReducers,
  effects: physicianListEffects,
});
